var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_176)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 32.4444C26.2396 32.4444 28.3875 31.5548 29.9711 29.9711C31.5548 28.3875 32.4444 26.2396 32.4444 24C32.4444 21.7604 31.5548 19.6125 29.9711 18.0289C28.3875 16.4452 26.2396 15.5555 24 15.5555C21.7604 15.5555 19.6125 16.4452 18.0289 18.0289C16.4452 19.6125 15.5555 21.7604 15.5555 24C15.5555 26.2396 16.4452 28.3875 18.0289 29.9711C19.6125 31.5548 21.7604 32.4444 24 32.4444Z",
    stroke: "#FF9117",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 32.4444V15.5556C5 12.756 6.1121 10.0712 8.09165 8.09165C10.0712 6.1121 12.756 5 15.5556 5H32.4444C35.244 5 37.9288 6.1121 39.9084 8.09165C41.8879 10.0712 43 12.756 43 15.5556V32.4444C43 35.244 41.8879 37.9288 39.9084 39.9084C37.9288 41.8879 35.244 43 32.4444 43H15.5556C12.756 43 10.0712 41.8879 8.09165 39.9084C6.1121 37.9288 5 35.244 5 32.4444Z",
    stroke: "#FF9117",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 12.4101L35.6322 12.3868",
    stroke: "#FF9117",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 32.4444C26.2396 32.4444 28.3875 31.5548 29.9711 29.9711C31.5548 28.3875 32.4444 26.2396 32.4444 24C32.4444 21.7604 31.5548 19.6125 29.9711 18.0289C28.3875 16.4452 26.2396 15.5555 24 15.5555C21.7604 15.5555 19.6125 16.4452 18.0289 18.0289C16.4452 19.6125 15.5555 21.7604 15.5555 24C15.5555 26.2396 16.4452 28.3875 18.0289 29.9711C19.6125 31.5548 21.7604 32.4444 24 32.4444Z",
    stroke: "#FFDF22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 32.4444V15.5556C5 12.756 6.1121 10.0712 8.09165 8.09165C10.0712 6.1121 12.756 5 15.5556 5H32.4444C35.244 5 37.9288 6.1121 39.9084 8.09165C41.8879 10.0712 43 12.756 43 15.5556V32.4444C43 35.244 41.8879 37.9288 39.9084 39.9084C37.9288 41.8879 35.244 43 32.4444 43H15.5556C12.756 43 10.0712 41.8879 8.09165 39.9084C6.1121 37.9288 5 35.244 5 32.4444Z",
    stroke: "#FFDF22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6111 12.4101L35.6322 12.3868",
    stroke: "#FFDF22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_176",
    x: -2.8,
    y: -2.8,
    width: 53.6,
    height: 53.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.568627 0 0 0 0 0.0901961 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.da0e4e8f073f9bbaf3af0eae9a7aae91.svg";
export { ForwardRef as ReactComponent };